import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { useRegistration } from './RegistrationContext';
export const BonusSection = () => {
  const {
    openPopup
  } = useRegistration();
  return <section className="mb-12" data-id="element-120" data-mp="22g532nfee2oa">
      <div className="w-full mb-6" data-id="element-121" data-mp="22ebwt98p5kgt">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5cB7x4JBKLA2SGnQ1mna3u/Scherm%C2%ADafbeelding_2025-08-15_om_15.46.41.png" alt="Vrouw wandelt ontspannen met haar hond op een bospad in de namiddagzon" className="w-full h-auto rounded-lg" data-id="element-122" data-mp="22dah2rgqk9sr" />
        <p className="text-xs text-gray-500 mt-2 text-center italic" data-id="element-123" data-mp="15njc1yatj48p">
          Een stressvrij leven voor je hond. En voor jou.
        </p>
      </div>

      <div className="bg-green-50 border border-green-200 rounded-xl p-8" data-id="element-124" data-mp="1eozn889gjadz">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-125" data-mp="qzya47pojb2d">
          Speciale Bonus Voor Deelnemers:
        </h3>

        <p className="text-gray-800 leading-relaxed mb-6 text-lg" data-id="element-126" data-mp="mzo1soef08kc">
          Als bonus ontvangen deelnemers een speciale verrassing die Amee pas
          tijdens het webinar onthult - iets dat liefdevolle baasjes helpt om
          direct hun hond beter te begrijpen.
        </p>

        <div className="space-y-5 mb-8" data-id="element-127" data-mp="2jhcukufb77za">
          <div className="flex items-start" data-id="element-128" data-mp="2jiegxv1rzgwb">
            <CheckCircle2Icon className="w-7 h-7 text-green-600 mr-4 mt-0.5 flex-shrink-0" data-id="element-129" data-mp="2ogpsqbbms1h6" />
            <span className="text-gray-800 text-lg" data-id="element-130" data-mp="1qt8oi7stssw2">
              De opname wordt naar alle deelnemers gestuurd
            </span>
          </div>
          <div className="flex items-start" data-id="element-131" data-mp="1vt3em94s1eg2">
            <CheckCircle2Icon className="w-7 h-7 text-green-600 mr-4 mt-0.5 flex-shrink-0" data-id="element-132" data-mp="20renagjc5iwp" />
            <span className="text-gray-800 text-lg" data-id="element-133" data-mp="20trcnerfavjs">
              Je kunt deelnemen vanaf je telefoon, tablet of computer
            </span>
          </div>
          <div className="flex items-start" data-id="element-134" data-mp="3c5s5p5vbl65c">
            <CheckCircle2Icon className="w-7 h-7 text-green-600 mr-4 mt-0.5 flex-shrink-0" data-id="element-135" data-mp="3h5mxrcqu01rz" />
            <span className="text-gray-800 text-lg" data-id="element-136" data-mp="3h7hlszxega0a">
              Speciale verrassingsbonus tijdens het webinar
            </span>
          </div>
        </div>

        <button onClick={openPopup} className="w-full bg-green-700 hover:bg-green-800 text-white font-bold py-4 px-6 rounded-xl transition-colors text-lg" data-id="element-137" data-mp="1c3iwvlk4f9nz">
          JA, IK WIL DEZE BONUSSEN - SCHRIJF ME IN!
        </button>
      </div>
    </section>;
};